export const style = {
  nonEditable: {
    cursor: `default`
  },
  title: {
    color: `black`
  },
  content: {
    color: `black`
  },
  edit: {
    color: `black`
  },
  editSpan: {
    marginLeft: `5px`
  },
  nonEditableEdit: {
    opacity: 0
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Settings/partials/SettingsEditor/style/ColorBlind/tableRow.js